import React, { useEffect, useState, useRef } from "react";
import { registrarTap } from "../api";

const Gallery = ({ images, id_sucursal, userId }) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  useEffect(() => {
    setIndex(0);
    setOpen(false);
  }, [images, id_sucursal]);

  const openViewer = (i) => {
    registrarTap(id_sucursal, "galeria", userId || null);
    setIndex(i);
    setOpen(true);
  };

  const closeViewer = () => setOpen(false);

  const prev = () => {
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const next = () => {
    setIndex((prev) => (prev + 1) % images.length);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    const delta = touchStartX.current - touchEndX.current;
    if (delta > 50) next();
    else if (delta < -50) prev();
  };

  return (
    <div className="gallery-container">
      <div className="gallery-grid-varied">
        {images.slice(0, 5).map((src, idx) => (
          <div
            key={idx}
            className={`gallery-box gallery-pos-${idx + 1}`}
            onClick={() => openViewer(idx)}
          >
            <img src={src} alt={`img-${idx}`} />
          </div>
        ))}
      </div>

      {open && (
        <div
          className="gallery-lightbox"
          onClick={closeViewer}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div className="gallery-lightbox-inner" onClick={(e) => e.stopPropagation()}>
            <button className="gallery-close" onClick={closeViewer}>×</button>
            <button className="gallery-prev" onClick={prev}>‹</button>
            <img src={images[index]} alt="Vista ampliada" />
            <button className="gallery-next" onClick={next}>›</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
